import React from "react"

export default function Students({
  strokeDasharray,
  strokeDashoffset = 78.54,
  className,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 100 100"
      className={className}
    >
      <path
        fill="#000"
        d="M50.4 40.622h9.286v2.277a5.882 5.882 0 014.1-1.665 5.911 5.911 0 015.905 5.905l-.003 5.515 2.65 10.276h-4.244v9.47h-2.718v-9.469h-3.178v9.47H59.48v-9.47h-4.244l1.98-7.642H50.4V40.622zm18.423 19.59l-1.795-6.929-.056-6.144a3.19 3.19 0 00-3.187-3.187 3.19 3.19 0 00-3.186 3.187l-.003 5.676-1.85 7.398h10.077zM53.128 52.56h3.83v-6.827l-3.83 2.9v3.927zm0-7.35l2.454-1.86h-2.454v1.86zm.479-5.733c.404-.653 1.244-3.095 2.815-3.047 1.432.041 1.533 1.306 1.533 1.532 0 2.239-3.22 2.166-4.348 1.515zm10.177 1.459a6.075 6.075 0 01-6.068-6.068 6.075 6.075 0 016.068-6.068 6.075 6.075 0 016.069 6.068 6.075 6.075 0 01-6.069 6.068zm3.34-6.188a9.445 9.445 0 01-2.4-1.347c-.863 1.244-2.153 2.5-3.793 3.198a3.341 3.341 0 002.854 1.619 3.355 3.355 0 003.351-3.35c0-.042-.011-.08-.013-.12zM39.233 58.324h-2.718v14.077h2.718V58.324zm5.897 0h-2.72v14.077h2.718V58.324z"
      />
      <path
        fill="#000"
        d="M40.822 41.234c-1.637 0-3.14.568-4.336 1.51v-1.062H27.2V56.35h6.596v1.975h2.718V48.262a4.314 4.314 0 014.308-4.31 4.314 4.314 0 014.308 4.31v10.063h2.718V48.262a7.034 7.034 0 00-7.026-7.028zm-10.894 3.177h2.455l-2.455 1.86v-1.86zm3.83 9.21h-3.83v-3.927l3.83-2.901v6.828zm7.065-12.685a6.075 6.075 0 006.068-6.068 6.074 6.074 0 00-6.068-6.068 6.075 6.075 0 00-6.069 6.068 6.074 6.074 0 006.07 6.068zm1.925-8.285l.86.358c.356.532.565 1.17.565 1.858a3.354 3.354 0 01-3.35 3.35 3.34 3.34 0 01-2.885-1.675c1.741-.61 3.692-2.25 4.81-3.89z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="10"
        d="M50 5a45 45 0 110 90 45 45 0 010-90h0z"
      />
      <circle
        cx="50"
        cy="50"
        r="45"
        stroke="hsl(var(--color-kkm-yellow))"
        strokeDasharray={strokeDasharray}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        fill="#000"
        d="M50.4 40.622h9.286v2.277a5.882 5.882 0 014.1-1.665 5.911 5.911 0 015.905 5.905l-.003 5.515 2.65 10.276h-4.244v9.47h-2.718v-9.469h-3.178v9.47H59.48v-9.47h-4.244l1.98-7.642H50.4V40.622zm18.423 19.59l-1.795-6.929-.056-6.144a3.19 3.19 0 00-3.187-3.187 3.19 3.19 0 00-3.186 3.187l-.003 5.676-1.85 7.398h10.077zM53.128 52.56h3.83v-6.827l-3.83 2.9v3.927zm0-7.35l2.454-1.86h-2.454v1.86zm.479-5.733c.404-.653 1.244-3.095 2.815-3.047 1.432.041 1.533 1.306 1.533 1.532 0 2.239-3.22 2.166-4.348 1.515zm10.177 1.459a6.075 6.075 0 01-6.068-6.068 6.075 6.075 0 016.068-6.068 6.075 6.075 0 016.069 6.068 6.075 6.075 0 01-6.069 6.068zm3.34-6.188a9.445 9.445 0 01-2.4-1.347c-.863 1.244-2.153 2.5-3.793 3.198a3.341 3.341 0 002.854 1.619 3.355 3.355 0 003.351-3.35c0-.042-.011-.08-.013-.12zM39.233 58.324h-2.718v14.077h2.718V58.324zm5.897 0h-2.72v14.077h2.718V58.324z"
      />
      <path
        fill="#000"
        d="M40.822 41.234c-1.637 0-3.14.568-4.336 1.51v-1.062H27.2V56.35h6.596v1.975h2.718V48.262a4.314 4.314 0 014.308-4.31 4.314 4.314 0 014.308 4.31v10.063h2.718V48.262a7.034 7.034 0 00-7.026-7.028zm-10.894 3.177h2.455l-2.455 1.86v-1.86zm3.83 9.21h-3.83v-3.927l3.83-2.901v6.828zm7.065-12.685a6.075 6.075 0 006.068-6.068 6.074 6.074 0 00-6.068-6.068 6.075 6.075 0 00-6.069 6.068 6.074 6.074 0 006.07 6.068zm1.925-8.285l.86.358c.356.532.565 1.17.565 1.858a3.354 3.354 0 01-3.35 3.35 3.34 3.34 0 01-2.885-1.675c1.741-.61 3.692-2.25 4.81-3.89z"
      />
    </svg>
  )
}
